<template>
  <v-container class="pa-0" fluid>
    <v-row class="ma-0 ma-md-2">
      <v-col cols="12" md="8" offset-md="2">
        <videon-card heading="Welcome" max-width="640" flat>
          <v-card-text>
            <p class="body-1 mb-4">
              Welcome to LiveEdge Cloud. You can get started using the navigation menu on the left.
            </p>
            
            <p class="subtitle-2 mb-2">Where to find your devices</p>
            
            <p class="body-2 mb-3">
              <strong>Assigned Devices</strong> shows only devices that have been individually assigned to you. 
              If you're looking for devices that belong to a fleet, they won't appear here.
            </p>
            
            <p class="body-2 mb-4">
              <strong>Fleets</strong> shows the fleets you have access to. To view or manage devices 
              within a fleet, open the fleet first. Fleet devices are managed through their fleet, 
              not through individual assignment.
            </p>
            
            <p class="body-2 mb-4 text--secondary">
              Need access to organization features like alerts and reporting? Select an organization below.
            </p>
            
            <v-row v-if="organizations.length > 0">
              <v-col cols="12">
                <v-btn
                  color="primary"
                  @click="goToOrgSelect"
                  block
                  large
                >
                  <v-icon left>house</v-icon>
                  Select Organization
                </v-btn>
              </v-col>
            </v-row>
            
            <p v-if="organizations.length == 0" class="body-2 text--secondary mt-2">
              Waiting for an invitation? Make sure your email <strong>{{ email }}</strong> matches the invitation.
              <a 
                class="primary--text ml-1" 
                href="https://support.videonlabs.com/hc/en-us/articles/12883463391251-How-do-I-get-invited-to-an-organization-in-LiveEdge-Cloud-" 
                target="_blank"
              >
                Learn more
              </a>.
            </p>
          </v-card-text>
        </videon-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: "Welcome",
    computed: {
      ...mapGetters('user', ['email', 'organizations']),
    },
    methods: {
      goToOrgSelect() {
        this.$store.dispatch('user/setStage', 'organization_selection').then(() => {
          this.$router.push('/auth/organizations')
        })
      }
    }
  }
</script>
